<template>
  <video
    v-if="isAsset(video)"
    ref="media"
    :alt="getVideoAlt(video?.asset)"
    :autoplay="autoplay"
    :loop="showVideoInLoop"
    :poster="
      imageResizerPath(image, DIMENSIONS_XL.ratio.video.width, DIMENSIONS_XL.ratio.video.height)
    "
    :src="load ? getVideoSrc(video?.asset) : null"
    :title="getVideoTitle(video?.asset)"
    :controls="showControls"
    playsinline
    @ended="trackCompletedVideoEvent()"
    @play="trackStartVideo = true"
    @pause="trackPauseVideoEvent()"
    @timeupdate="trackOnVideoProgress"
  ></video>
  <video
    v-else-if="isExternal(video)"
    ref="media"
    :autoplay="autoplay"
    :loop="showVideoInLoop"
    :poster="
      imageResizerPath(image, DIMENSIONS_XL.ratio.video.width, DIMENSIONS_XL.ratio.video.height)
    "
    :src="load ? video.url : null"
    :controls="showControls"
    playsinline
    @ended="trackCompletedVideoEvent()"
    @play="trackStartVideo = true"
    @pause="trackPauseVideoEvent()"
    @timeupdate="trackOnVideoProgress"
  ></video>
  <div v-else-if="isYoutube(video)" class="relative">
    <iframe
      ref="media"
      :src="
        load
          ? `https://www.youtube-nocookie.com/embed/${getYouTubeId(video?.youtube)}?color=white&playsinline=1&autoplay=${autoplay ? '1' : '0'}&controls=1&fs=1&rel=0&enablejsapi=1`
          : null
      "
      allowfullscreen="allowfullscreen"
      class="yt-iframe aspect-video h-full w-full"
      border="0"
    ></iframe>
    <div class="yt-hint absolute inset-0 items-center justify-center">
      <div class="mx-auto w-10/12 text-center text-white md:w-1/2">
        <CommonLabel path="BWF/shared/youtubeConsentHint" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { imageResizerPath } from "~/utils/helper/magnolia";
import {
  getVideoSrc,
  isAsset,
  isYoutube,
  isExternal,
  getYouTubeId,
  getVideoAlt,
  getVideoTitle,
} from "~/utils/helper/video";
import { DIMENSIONS_XL } from "~/utils/helper/imaging";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const props = defineProps(["image", "video", "load", "autoplay", "showVideoInLoop", "controls"]);

const showControls = computed(() => props.controls !== false);

const media = ref(null);

const { trackCompletedVideoEvent, trackOnVideoProgress, trackStartVideo, trackPauseVideoEvent } =
  useVideoTracking(media, props.video);
function playVideo() {
  media?.value?.play();
}
function pauseVideo() {
  media?.value?.pause();
}

defineExpose({ playVideo, pauseVideo, media });
</script>

<style scoped>
.yt-hint {
  @apply hidden;
}

.yt-iframe[data-cmp-src] + .yt-hint {
  @apply flex;
}
</style>
